import { render, staticRenderFns } from "./LeadsInfo.vue?vue&type=template&id=42f58ca8&"
import script from "./LeadsInfo.vue?vue&type=script&lang=js&"
export * from "./LeadsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports